import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  checkboxSection: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    margin: '16px 0',
    '&>span': {
      marginRight: 8,
    },
    '&>span.Mui-checked + p': {
      fontWeight: 700,
    },
    '& span': {
      width: 24,
      height: 24,
      padding: 0,
      '& input': {
        width: 'inherit',
        height: 'inherit',
      },
    },
  },
  primary: {
    '& $checkboxIcon': {
      borderColor: theme.palette.primary.dark,
    },
    '& $checkboxIconActive': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  secondary: {
    '& $checkboxIcon': {
      borderColor: theme.palette.secondary.dark,
    },
    '& $checkboxIconActive': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  checkboxIcon: {
    height: 24,
    width: 24,
    borderWidth: 2,
    borderStyle: 'solid',
    borderRadius: 4,
  },
  checkboxIconActive: {
    borderRadius: 4,
    color: '#fff',
    height: 24,
    width: 24,
    padding: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'inherit',
    '& i': { fontWeight: 700, fontSize: 18 },
  },
}));

export default useStyles;
